import { matchPath, useLocation } from 'react-router-dom';
import { ROUTE_TITLES, type RoutePattern } from '../constants';
import { useAppStore } from '../stores';

/**
 * Hook para obtener el título de la ruta actual
 * Prioriza el título del store, con fallback a mapeo de rutas
 * Soporta rutas con parámetros usando matchPath
 */
export const useReadingTitle = () => {
  const location = useLocation();
  const titleMaintainer = useAppStore((state) => state.titleMaintainer);

  /**
   * Función para buscar el título correspondiente a la ruta actual
   * usando matchPath para el soporte de parámetros dinámicos
   */
  const getRouteTitle = (pathName: string): string => {
    // Iteración sobre todos los patterns de rutas
    for (const pattern of Object.keys(ROUTE_TITLES) as RoutePattern[]) {
      const match = matchPath({ path: pattern }, pathName);

      if (match) return ROUTE_TITLES[pattern];
    }

    return 'Página no encontrada';
  };

  // usar el título del store si existe, de lo contrario usar mapeo de ruta
  const resolvedTitle = titleMaintainer || getRouteTitle(location.pathname);

  return { title: resolvedTitle };
};
